export default __webpack_public_path__ + "static/media/root.78b0c752.svg";